import * as React from 'react';
import InvestmentProfileCardComponent
  from 'src/modules/modals/investment-funnel/partials/InvestmentProfileCard.component';
import Person from 'src/entities/Person';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import ShowPhysicalProfileComponent
  from 'src/modules/project/partials/project-formalization/partials/confirm-profile/ShowPhysicalProfile.component';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import ShowJuridicalProfileComponent
  from 'src/modules/project/partials/project-formalization/partials/confirm-profile/ShowJuridicalProfile.component';
import IncompleteProfileComponent
  from 'src/modules/project/partials/project-formalization/partials/confirm-profile/IncompleteProfile.component';

export interface ConfirmProfileProps {
  person: Person;
  handleConfirmProfile: () => void;
  handleChangeProfile: () => void;
  defaultProfile: boolean;
  activeProfile: boolean;
  physicalPerson?: PhysicalPerson;
  juridicalPerson?: JuridicalPerson;
}

const ConfirmProfileComponent: React.StatelessComponent<ConfirmProfileProps> = (props: ConfirmProfileProps) => {

  return (
    <div>
      <div className="gap-20"/>
      <p className="f-s-20">Perfil de inversión:</p>

      <div className="row">
        <InvestmentProfileCardComponent
          name={props.person.displayName}
          activeProfile={props.activeProfile}
          defaultProfile={props.defaultProfile}
          juridical={(props.person.personType !== 'physical')}
        />
      </div>
      {props.person.personType === 'physical' ?
        (props.physicalPerson!.isProfileCompleted() ?
          <ShowPhysicalProfileComponent person={props.physicalPerson!}/> :
          <IncompleteProfileComponent
              title="Datos incompletos"
              message={'Debes completar todos los datos de tu perfil físico antes de continuar con el proceso de ' +
              'formalización. Haz click en el botón modificar para ir directamente al formulario de edición del ' +
              'perfil.'}
          />
        ) : null
      }
      {props.person.personType === 'juridical' ?
        (props.juridicalPerson!.isProfileCompleted() ?
          <ShowJuridicalProfileComponent person={props.juridicalPerson!}/> :
          <IncompleteProfileComponent
              title="Datos incompletos"
              message={'Debes completar todos los datos de tu perfil jurídico antes de continuar con el proceso de ' +
              'formalización. Haz click en el botón modificar para ir directamente al formulario de edición del ' +
              'perfil.'}
          />
        ) : null
      }
      <p>
        <button
          className="btn btn-primary margin-r-10"
          onClick={() => props.handleChangeProfile()}
        >
          Modificar
        </button>
        {(props.physicalPerson && props.person.personType === 'physical' && !props.physicalPerson.isProfileCompleted())
        || (props.juridicalPerson && props.person.personType === 'juridical' &&
         !props.juridicalPerson.isProfileCompleted()) ?
          null :
          <button
            className="btn btn-secondary"
            onClick={() => props.handleConfirmProfile()}
          >
            Confirmar
          </button>
        }

      </p>
      <div className="gap-50"/>
    </div>
  );
};

export default ConfirmProfileComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-profile/ConfirmProfile.component.tsx